import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { Button } from '../../../components/ui/button';
import styles from './EditSegment.module.css';

interface EditSegmentHeaderProps {
  onBack: () => void;
  onSave: () => void;
  isSaveDisabled: boolean;
  isSaving: boolean;
  saveLabel?: string;
  /** Actions rendered left of Save — e.g. the tenant-selection trigger. */
  children?: React.ReactNode;
}

export const EditSegmentHeader: React.FC<EditSegmentHeaderProps> = ({
  onBack,
  onSave,
  isSaveDisabled,
  isSaving,
  saveLabel = 'Save Segment',
  children,
}) => {
  return (
    <header className={styles.header}>
      <button type="button" onClick={onBack}>
        <ArrowLeft />
        Back to Segments
      </button>
      <div className={styles.headerActions}>
        {children}
        <Button onClick={onSave} disabled={isSaveDisabled}>
          {isSaving ? 'Saving...' : saveLabel}
        </Button>
      </div>
    </header>
  );
};
